// Generate short ID with 3 letters and 3 numbers
export const generateShortId = (): string => {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';
  
  let result = '';
  // Add 3 random letters
  for (let i = 0; i < 3; i++) {
    result += letters.charAt(Math.floor(Math.random() * letters.length));
  }
  // Add 3 random numbers
  for (let i = 0; i < 3; i++) {
    result += numbers.charAt(Math.floor(Math.random() * numbers.length));
  }
  return result;
};

// Generate customer ID (3 letters + 3 numbers)
export const generateCustomerId = (): string => {
  return generateShortId();
};

// Generate order ID (3 letters + 3 numbers)
export const generateOrderId = (): string => {
  return generateShortId();
};
